export enum EBiteJumpLocationType {
  EBiteJumpLocation_Off = 0,
  EBiteJumpLocation_Start = 1,
  EBiteJumpLocation_All = 2,
  EBiteJumpLocation_End = 3,
}

export interface IPresetupOptions {
  upperArch: Blob
  lowerArch: Blob
  canvas: HTMLCanvasElement
  donecallback: () => void
}

export interface HoverToothData {
  isShow: boolean
  toothid: number
  isUpper: boolean
  position: [number, number]
  hoverString: string
  properties: {
    isCrown: boolean
    isImplant: boolean
    isBridge: boolean
    isPontic: boolean
    isPrimary: boolean
    isErupting: boolean
  }
}

/**
 *  STLModel Preview of Uploading & Fillinghole
 */
export interface IDrawSTLOps {
  upperArch: File | null
  lowerArch: File | null
  canvas: HTMLCanvasElement
  zoomRange: [number, number]
  fillholeCallback?: (isSuccess: boolean, errmsg: string) => void
  onZoomChange?: (zoomScaleVal: number) => void
  isShowRefinement?: boolean
}

/**
 *the options of drawRefinementSTL
 */
export interface IDrawRefinementSTLOps {
  upperArch: File | null
  lowerArch: File | null
  zoomRange: [number, number]
}
